import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { StackView } from '@telus-uds/components-web';

import request from '../../../utils/request';
import Note from '../../../note';
import FilesList from './filesList';
import FileUpload from './fileUpload';

const FieldMultiFileUpload = ({ data, orderData }) => {
  const { name, maximumFileSize, note, isShowNoteBackground, label, required } = data;
  const orderId = orderData && orderData.id;
  const [filesList, setFilesList] = useState([]);

  useEffect(() => {
    if (!orderId) return;
    request
      .get(`/orders/${orderId}`)
      .then(response => {
        const attachments =
          (response.data && response.data.attachments) || [];
        const filtered = attachments.filter(a => a.key === name);
        setFilesList(filtered);
        if (data.onChange) {
          data.onChange({ target: { name, fileUploded: filtered.length > 0 } });
        }
      })
      .catch(() => {});
  }, [orderId]); // eslint-disable-line react-hooks/exhaustive-deps

  const addFileToList = newFiles => {
    setFilesList(prev => {
      const updated = [...prev, ...newFiles];
      if (data.onChange) {
        data.onChange({ target: { name, fileUploded: updated.length > 0 } });
      }
      return updated;
    });
  };

  const removeFileFromList = id => {
    setFilesList(prev => {
      const updated = prev.filter(file => file.id !== id);
      if (data.onChange) {
        data.onChange({ target: { name, fileUploded: updated.length > 0 } });
      }
      return updated;
    });
  };

  return (
    <div style={{ marginBottom: '2rem' }}>
      {label && (
        <span className="frg-body-font-14px">
          {label}{required && '*'}
        </span>
      )}
      {note && note.content && (
        <Note type="richText" data={note} isShowNoteBackground={isShowNoteBackground} />
      )}
      <StackView space={3}>
        <FileUpload
          addFileToList={addFileToList}
          orderId={orderId}
          fieldName={name}
          maximumFileSize={maximumFileSize}
        />
        {filesList.length > 0 && (
          <FilesList
            filesList={filesList}
            orderId={orderId}
            removeFileFromList={removeFileFromList}
          />
        )}
      </StackView>
    </div>
  );
};

FieldMultiFileUpload.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string.isRequired,
    maximumFileSize: PropTypes.number,
    onChange: PropTypes.func
  }).isRequired,
  orderData: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  })
};

FieldMultiFileUpload.defaultProps = {
  orderData: null
};

export default FieldMultiFileUpload;
